import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

export default function Dashboard() {
  const [tab, setTab] = useState('firme');
  const navigate = useNavigate();

  function logout() {
    localStorage.removeItem('token');
    navigate('/login');
  }

  return (
    <div style={{ maxWidth: 1100, margin: '0 auto', padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h1>Stocuri Manager</h1>
        <div className="logout" style={{ cursor: 'pointer', color: '#c0392b' }} onClick={logout}>Iesire</div>
      </div>

      <div className="tabs">
        <button type="button" className={`tab-btn${tab === 'firme' ? ' activ' : ''}`} onClick={() => setTab('firme')}>Cereri &amp; Firme</button>
        <button type="button" className={`tab-btn${tab === 'jurnal' ? ' activ' : ''}`} onClick={() => setTab('jurnal')}>Jurnal</button>
        <button type="button" className={`tab-btn${tab === 'backup' ? ' activ' : ''}`} onClick={() => setTab('backup')}>Backup-uri</button>
      </div>

      {tab === 'firme' && <TabFirme />}
      {tab === 'jurnal' && <TabJurnal />}
      {tab === 'backup' && <TabBackup />}
    </div>
  );
}

// --- Tab "Cereri & Firme" ---------------------------------------------------
function TabFirme() {
  const [cereri, setCereri] = useState([]);
  const [firme, setFirme] = useState([]);
  const [loading, setLoading] = useState(true);
  const [rezultat, setRezultat] = useState(null);
  const [showNouaFirma, setShowNouaFirma] = useState(false);
  const [form, setForm] = useState({ numeFirma: '', cui: '', persoanaContact: '', telefon: '', email: '' });
  const [eroare, setEroare] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  function incarca() {
    setLoading(true);
    Promise.all([api.get('/api/admin/cereri'), api.get('/api/admin/firme')])
      .then(([c, f]) => { setCereri(c.data); setFirme(f.data); })
      .finally(() => setLoading(false));
  }

  useEffect(incarca, []);

  async function aproba(id) {
    if (!window.confirm('Aprobi aceasta cerere? Se va crea automat o baza de date noua.')) return;
    try {
      const res = await api.post(`/api/admin/cereri/${id}/aproba`);
      setRezultat(res.data);
      incarca();
    } catch (err) {
      alert(err.response?.data?.error || 'Eroare la aprobare');
    }
  }

  async function respinge(id) {
    const motiv = window.prompt('Motiv respingere (optional):');
    await api.post(`/api/admin/cereri/${id}/respinge`, { motiv });
    incarca();
  }

  function deschideNouaFirma() {
    setForm({ numeFirma: '', cui: '', persoanaContact: '', telefon: '', email: '' });
    setEroare(null);
    setShowNouaFirma(true);
  }

  async function salveazaFirmaNoua(e) {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    setEroare(null);
    try {
      const res = await api.post('/api/admin/firme', form);
      setShowNouaFirma(false);
      setRezultat(res.data);
      incarca();
    } catch (err) {
      setEroare(err.response?.data?.error || 'Eroare la crearea firmei');
    } finally {
      setSubmitting(false);
    }
  }

  async function retrimiteParola(f) {
    if (!window.confirm(`Trimiti date de logare noi catre ${f.email}? Parola veche nu va mai functiona.`)) return;
    try {
      const res = await api.post(`/api/admin/firme/${f.id}/retrimite-parola`);
      alert(res.data.mesaj || 'Date de logare retrimise');
    } catch (err) {
      alert(err.response?.data?.error || 'Eroare la retrimitere');
    }
  }

  if (loading) return <p>Se incarca...</p>;

  return (
    <>
      <div className="card">
        <h2 style={{ marginTop: 0, fontSize: 16 }}>Cereri in asteptare ({cereri.length})</h2>
        <table>
          <thead><tr><th>Firma</th><th>Contact</th><th>Email</th><th>Data</th><th></th></tr></thead>
          <tbody>
            {cereri.map(c => (
              <tr key={c.id}>
                <td>{c.numeFirma}</td>
                <td>{c.persoanaContact}</td>
                <td>{c.email}</td>
                <td>{c.dataCerere ? new Date(c.dataCerere).toLocaleDateString('ro-RO') : '-'}</td>
                <td>
                  <button className="btn" onClick={() => aproba(c.id)}>Aproba</button>{' '}
                  <button className="btn danger" onClick={() => respinge(c.id)}>Respinge</button>
                </td>
              </tr>
            ))}
            {cereri.length === 0 && <tr><td colSpan="5">Nicio cerere in asteptare.</td></tr>}
          </tbody>
        </table>
      </div>

      <div className="card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h2 style={{ marginTop: 0, fontSize: 16 }}>Firme ({firme.length})</h2>
          <button type="button" className="btn" onClick={deschideNouaFirma}>+ Firma noua (direct)</button>
        </div>
        <table>
          <thead><tr><th>Nume</th><th>Email</th><th>Status</th><th>Baza de date</th><th></th></tr></thead>
          <tbody>
            {firme.map(f => (
              <tr key={f.id}>
                <td>{f.numeFirma}</td>
                <td>{f.email}</td>
                <td><span className={`badge ${f.status === 'aprobat' ? 'ok' : 'alerta'}`}>{f.status}</span></td>
                <td>{f.dbName || '-'}</td>
                <td><button type="button" className="btn secondary" onClick={() => retrimiteParola(f)}>Retrimite date logare</button></td>
              </tr>
            ))}
            {firme.length === 0 && <tr><td colSpan="5">Nicio firma inca.</td></tr>}
          </tbody>
        </table>
      </div>

      {showNouaFirma && (
        <div className="modal-overlay" onClick={() => setShowNouaFirma(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h2>Firma noua - creare directa</h2>
            <p style={{ fontSize: 13, color: '#888', marginTop: -8 }}>
              Se creeaza imediat baza de date + primul cont admin, fara sa astepte o cerere.
            </p>
            <form onSubmit={salveazaFirmaNoua}>
              {eroare && <p style={{ color: '#c0392b', fontSize: 13 }}>{eroare}</p>}
              <div className="field">
                <label>Nume firma *</label>
                <input value={form.numeFirma} onChange={e => setForm({ ...form, numeFirma: e.target.value })} required autoFocus />
              </div>
              <div className="field-row">
                <div className="field">
                  <label>CUI</label>
                  <input value={form.cui} onChange={e => setForm({ ...form, cui: e.target.value })} />
                </div>
                <div className="field">
                  <label>Telefon</label>
                  <input value={form.telefon} onChange={e => setForm({ ...form, telefon: e.target.value })} />
                </div>
              </div>
              <div className="field">
                <label>Persoana de contact</label>
                <input value={form.persoanaContact} onChange={e => setForm({ ...form, persoanaContact: e.target.value })} />
              </div>
              <div className="field">
                <label>Email administrator *</label>
                <input type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required />
                <p style={{ fontSize: 12, color: '#888', margin: '4px 0 0' }}>
                  Login-ul din stocuri se va directiona automat catre aceasta firma, pe baza acestui email.
                </p>
              </div>
              <div className="modal-actions">
                <button type="button" className="btn danger" onClick={() => setShowNouaFirma(false)}>Anuleaza</button>
                <button type="submit" className="btn" disabled={submitting}>{submitting ? 'Se creeaza...' : 'Creeaza firma'}</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {rezultat && (
        <div className="modal-overlay" onClick={() => setRezultat(null)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h2>Firma creata</h2>
            <p>Baza de date pentru firma <strong>{rezultat.firmaId}</strong> a fost creata.</p>
            <p>Transmite aceste date catre <strong>{rezultat.email}</strong>:</p>
            <p>Parola initiala: <code style={{ fontSize: 16, background: '#f0f1f3', padding: '4px 8px', borderRadius: 4 }}>{rezultat.parolaInitiala}</code></p>
            <div className="modal-actions">
              <button className="btn" onClick={() => setRezultat(null)}>Am notat</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

// --- Tab "Jurnal" ------------------------------------------------------------
const TIP_EVENIMENT_LABEL = {
  LOGIN_SUCCES: 'Login reusit', LOGIN_ESUAT: 'Login esuat', OPERATIUNE: 'Operatiune'
};

function TabJurnal() {
  const [jurnal, setJurnal] = useState([]);
  const [firme, setFirme] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dataInceput, setDataInceput] = useState('');
  const [dataSfarsit, setDataSfarsit] = useState('');
  const [tip, setTip] = useState('');
  const [firmaDbName, setFirmaDbName] = useState('');

  useEffect(() => {
    api.get('/api/admin/firme').then(res => setFirme(res.data));
  }, []);

  function incarca() {
    setLoading(true);
    const params = new URLSearchParams();
    if (dataInceput) params.set('dataInceput', dataInceput);
    if (dataSfarsit) params.set('dataSfarsit', dataSfarsit);
    if (tip) params.set('tip', tip);
    if (firmaDbName) params.set('firmaDbName', firmaDbName);
    api.get(`/api/admin/jurnal?${params.toString()}`).then(res => setJurnal(res.data)).finally(() => setLoading(false));
  }

  useEffect(incarca, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="card">
      <div className="toolbar">
        <input type="date" value={dataInceput} onChange={e => setDataInceput(e.target.value)} title="De la" />
        <input type="date" value={dataSfarsit} onChange={e => setDataSfarsit(e.target.value)} title="Pana la" />
        <select value={tip} onChange={e => setTip(e.target.value)}>
          <option value="">Toate aplicatiile</option>
          <option value="STOCURI">Stocuri</option>
          <option value="MANAGER">Stocuri Manager</option>
        </select>
        <select value={firmaDbName} onChange={e => setFirmaDbName(e.target.value)}>
          <option value="">Toate firmele</option>
          {firme.map(f => <option key={f.id} value={f.dbName}>{f.numeFirma}</option>)}
        </select>
        <button type="button" className="btn" onClick={incarca}>Filtreaza</button>
      </div>

      {loading ? <p>Se incarca...</p> : (
        <table>
          <thead>
            <tr>
              <th>Data/Ora</th><th>Aplicatie</th><th>Firma</th><th>Utilizator</th>
              <th>IP</th><th>Operatiune</th><th>Eveniment</th><th>Rezultat</th>
            </tr>
          </thead>
          <tbody>
            {jurnal.map(l => (
              <tr key={l.id} className={l.rezultat === 'EROARE' ? 'alerta' : ''}>
                <td>{l.dataOra ? new Date(l.dataOra).toLocaleString('ro-RO') : '-'}</td>
                <td>{l.tip === 'STOCURI' ? 'Stocuri' : 'Manager'}</td>
                <td>{l.firmaNumeAfisat || (l.tip === 'MANAGER' ? '-' : <em>necunoscuta</em>)}</td>
                <td>{l.utilizatorNume ? `${l.utilizatorNume} (${l.utilizatorEmail})` : (l.utilizatorEmail || <em>-</em>)}</td>
                <td>{l.ip || '-'}</td>
                <td>{l.metoda} {l.cale}</td>
                <td>{TIP_EVENIMENT_LABEL[l.tipEveniment] || l.tipEveniment}</td>
                <td><span className={`badge ${l.rezultat === 'SUCCES' ? 'ok' : 'alerta'}`}>{l.rezultat}{l.codRaspuns ? ` (${l.codRaspuns})` : ''}</span></td>
              </tr>
            ))}
            {jurnal.length === 0 && <tr><td colSpan="8">Niciun eveniment in perioada selectata.</td></tr>}
          </tbody>
        </table>
      )}
    </div>
  );
}

// --- Tab "Backup-uri" ---------------------------------------------------
function formatMarime(bytes) {
  if (bytes == null) return '-';
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}

function TabBackup() {
  const [istoric, setIstoric] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pornind, setPornind] = useState(false);
  const [restaurare, setRestaurare] = useState(null);
  const [confirmareText, setConfirmareText] = useState('');
  const [restaurand, setRestaurand] = useState(false);

  function incarca() {
    setLoading(true);
    api.get('/api/admin/backup').then(res => setIstoric(res.data)).finally(() => setLoading(false));
  }

  useEffect(incarca, []);

  async function porneesteBackupManual() {
    setPornind(true);
    try {
      const res = await api.post('/api/admin/backup/manual');
      alert(res.data.mesaj);
      setTimeout(incarca, 3000);
    } catch (err) {
      alert(err.response?.data?.error || 'Eroare la pornirea backup-ului');
    } finally {
      setPornind(false);
    }
  }

  function deschideRestaurare(b) {
    const numeAsteptat = b.tip === 'MASTER' ? 'MASTER' : b.firmaNume;
    setConfirmareText('');
    setRestaurare({ id: b.id, numeAsteptat, numeFisier: b.numeFisier });
  }

  async function confirmaRestaurare(e) {
    e.preventDefault();
    if (restaurand) return;
    setRestaurand(true);
    try {
      const res = await api.post(`/api/admin/backup/${restaurare.id}/restaureaza`, { confirmareNume: confirmareText });
      alert(res.data.mesaj);
      setRestaurare(null);
      incarca();
    } catch (err) {
      alert(err.response?.data?.error || 'Eroare la restaurare');
    } finally {
      setRestaurand(false);
    }
  }

  return (
    <div className="card">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <p style={{ margin: 0, fontSize: 13, color: '#888' }}>
          Backup automat zilnic la 1:30, pe FTPS extern - pastrat 90 de zile, apoi sters automat.
        </p>
        <button type="button" className="btn" onClick={porneesteBackupManual} disabled={pornind}>
          {pornind ? 'Se porneste...' : 'Backup manual'}
        </button>
      </div>

      {loading ? <p>Se incarca...</p> : (
        <table>
          <thead>
            <tr><th>Data</th><th>Tip</th><th>Firma</th><th>Fisier</th><th>Marime</th><th>Status</th><th></th></tr>
          </thead>
          <tbody>
            {istoric.map(b => (
              <tr key={b.id} className={b.status === 'EROARE' ? 'alerta' : ''}>
                <td>{b.dataCreare ? new Date(b.dataCreare).toLocaleString('ro-RO') : '-'}</td>
                <td>{b.tip === 'MASTER' ? 'Master' : 'Firma'}{b.esteUrgenta ? ' (urgenta)' : ''}</td>
                <td>{b.firmaNume || (b.tip === 'MASTER' ? '-' : <em>necunoscuta</em>)}</td>
                <td style={{ fontSize: 12, color: '#888' }}>{b.numeFisier}</td>
                <td>{formatMarime(b.marimeBytes)}</td>
                <td>
                  <span className={`badge ${b.status === 'SUCCES' ? 'ok' : 'alerta'}`}>{b.status}</span>
                  {b.motivEroare && <p style={{ fontSize: 11, color: '#c0392b', margin: '4px 0 0' }}>{b.motivEroare}</p>}
                </td>
                <td>
                  {b.status === 'SUCCES' && (
                    <button type="button" className="btn danger" onClick={() => deschideRestaurare(b)}>Restaureaza</button>
                  )}
                </td>
              </tr>
            ))}
            {istoric.length === 0 && <tr><td colSpan="7">Niciun backup inca.</td></tr>}
          </tbody>
        </table>
      )}

      {restaurare && (
        <div className="modal-overlay" onClick={() => setRestaurare(null)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h2>Restaurare backup</h2>
            <p style={{ fontSize: 13, color: '#c0392b' }}>
              Aceasta operatie suprascrie datele curente cu cele din fisierul <strong>{restaurare.numeFisier}</strong>.
              Tot ce s-a intamplat dupa data acestui backup se pierde ireversibil (se pastreaza insa automat un
              backup „de urgenta" al starii de acum, chiar inainte de suprascriere).
            </p>
            <form onSubmit={confirmaRestaurare}>
              <div className="field">
                <label>Scrie exact „{restaurare.numeAsteptat}" ca sa confirmi *</label>
                <input value={confirmareText} onChange={e => setConfirmareText(e.target.value)} required autoFocus />
              </div>
              <div className="modal-actions">
                <button type="button" className="btn secondary" onClick={() => setRestaurare(null)}>Anuleaza</button>
                <button type="submit" className="btn danger" disabled={restaurand || confirmareText !== restaurare.numeAsteptat}>
                  {restaurand ? 'Se restaureaza...' : 'Restaureaza definitiv'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
